// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1P9vu","emails":"CreateEditClinics_emails__2VJ6C","emailTagLabel":"CreateEditClinics_emailTagLabel__2Gd1y"};